module.exports = __webpack_public_path__ + "static/media/funflyaero.86372f9a.png";